import useAccessVoter from "v4/hooks/useAccessVoter";
export default function CustomerEventServiceVoter() {
    const {hasRole} = useAccessVoter();

    const canAccessCustomerEventService = () => {
        return hasRole('ROLE_SUPERADMIN') || hasRole('ROLE_SYSTEM');
    }

    return ({canAccessCustomerEventService})
}
